// import $ from 'jquery';
import { loadModal } from '../../AsyncLoader';
import dom from '../../utils/dom';
import ForgotPasswordService from './ForgotPasswordService';
import Content from './ForgotPasswordModalContent';
import ConfirmationModal from './ForgotPasswordConfirmationModal';
import type ForgotPasswordModalElements from './ForgotPasswordModalElements';
import type ModalHandle from '../../tnew/ui/Modal/ModalHandle';
import FormHandler, { FormHandlerOnSubmitOptions } from '../../forms/FormHandler';

const FORM_ID = 'tn-account-login-forgot-password-form';

function makeModalSubmitButton(labelHtml: string) {
  const $btn = dom.makeElement('button', {
    type: 'submit',
    class: 'modal-btn-confirm btn btn-primary tn-account-login-forgot-password-button-submit',
    form: FORM_ID,
  }) as HTMLButtonElement;

  $btn.innerHTML = labelHtml;

  return $btn;
}

function makeModalCancelbutton(labelHtml: string) {
  const $btn = dom.makeElement('button', {
    type: 'button',
    class: 'modal-btn-cancel btn btn-default',
  }) as HTMLButtonElement;

  $btn.innerHTML = labelHtml;

  return $btn;
}

class ForgotPasswordModalProvider {
  $username: HTMLInputElement;

  $resetLink: HTMLButtonElement;

  $form: HTMLFormElement;

  $inputLoginEmail: HTMLInputElement;

  $errorMessage: HTMLDivElement;

  modal: ModalHandle | undefined;

  $submitButton: HTMLButtonElement;

  $cancelButton: HTMLButtonElement;

  constructor(elements: typeof ForgotPasswordModalElements) {
    const el = elements.getAll();

    this.$username = el.$username;
    this.$resetLink = el.$resetLink;
    this.$form = el.$form;
    this.$inputLoginEmail = el.$inputLoginEmail;
    this.$errorMessage = el.$errorMessage;

    this.$submitButton = makeModalSubmitButton(Content.sendEmailButtonText);
    this.$cancelButton = makeModalCancelbutton(Content.cancelButtonText);
  }

  listen() {
    this.$resetLink.addEventListener('click', () => {
      const loginEmailValue = this.$inputLoginEmail.value;

      if (loginEmailValue) {
        this.$username.value = loginEmailValue;
      }

      this.showModal();
    });

    this.$form.append(this.$submitButton);

    this.$cancelButton.addEventListener('click', () => {
      if (this.modal) {
        this.modal.close();
      }
    });

    new FormHandler(this.$form, {
      onValidationSuccess: this.onSubmit,
    });
  }

  async showModal() {
    dom.hide(this.$errorMessage);

    const Modal = await loadModal();

    this.modal = Modal.open({
      title: Content.heading,
      bodyContents: this.$form,
      footerContents: [this.$submitButton, this.$cancelButton],
      returnFocusTo: this.$resetLink,
      describedById: 'tn-forgot-password-instructional-text',
    });
  }

  onSubmit = async ({ stopSubmitting }: FormHandlerOnSubmitOptions) => {
    const emailAddress = this.$username.value;

    dom.hide(this.$errorMessage);

    const response = await ForgotPasswordService.resetLogin(emailAddress);

    stopSubmitting();

    if (response.isSuccess) {
      this.modal!.close();

      ConfirmationModal.open({
        emailAddress,
        returnFocusTo: this.$resetLink,
      });
    } else {
      this.$errorMessage.innerHTML = response.message;

      dom.unhide(this.$errorMessage);
    }
  };
}

export default ForgotPasswordModalProvider;
